<div class="modal fade" id="magicInsightsGenerationModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content border-0 shadow-lg border-rounded-05">

      <div class="modal-header border-bottom-0 pb-0 pt-4 px-4">
        <h5 class="modal-title text-zint-dark-blue text-bold-600 font-size-1-5">
          <i class="far fa-sparkle text-zint-dark-blue mr-2"></i>Generate Magic Insights
        </h5>
        <button type="button" class="close text-grey-500 no-focus-outline" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-4 pb-4 pt-2">
        <div class="row">
          <div class="col-md-12">
            <div class="notice-box border-rounded-05 p-3 mt-2 mb-3 d-flex align-items-start">
              <i class="fal fa-clock text-bear-blue mr-3 mt-1 font-size-1-5"></i>
              <div class="text-grey-700 line-height-normal">

                @if(this.companyIds?.length === 1 || numberOfCompaniesMatchingSearchParams === 1){
                  <span>
                    As you have selected only 1 company, the answers to this company should be generated momentarily.
                    At peak times, this can take up to <strong>5 minutes</strong>.
                  </span>
                }
                @else if ((this.companyIds?.length > 1 || numberOfCompaniesMatchingSearchParams > 1) && (this.companyIds?.length <= 100 || numberOfCompaniesMatchingSearchParams <= 100)) {
                  <span>
                    Your selected companies will be queued up immediately for processing.
                    At peak times, this may take up to <strong>5 minutes</strong> to begin and up to <strong>30 minutes</strong> to complete.
                  </span>
                }
                @else if (this.companyIds?.length > 100 || numberOfCompaniesMatchingSearchParams > 100) {
                  <span>
                    As you have selected over 100 companies, the first 100 will be queued up for processing immediately
                    and will generally be processed within <strong>30 minutes</strong>.
                    The remainder of this batch will be processed over the next <strong>24 hours</strong>, but is usually much faster.
                  </span>
                }

              </div>
            </div>

            <div class="row mt-2">

              @if (showSelectionWarning) {
                  <div class="col-md-12 d-flex flex-column mb-2">
                        <div class="status-badge-orange border-rounded-05 mt-3 mb-3 p-2 d-flex align-items-center">
                            <i class="fal fa-exclamation-triangle mr-2"></i>
                            <span>Please select a maximum of <strong>{{ maximumCompaniesToGenerateViaQuery | number }}</strong> companies.</span>
                        </div>
                  </div>
              }

            @if(!isManualSelectionMode) {
                <div class="col-md-6 d-flex flex-column">
                  <div class="form-group mb-0">
                    <label class="text-grey-700 text-bold-600 text-sm mb-2">
                      Limit number of companies @if (!showSelectionWarning) {(Optional)}
                    </label>
                    <input type="number"
                           min="1"
                           max="50000"
                           class="form-control rounded-input-base text-grey-700"
                           placeholder="e.g. 500"
                           [(ngModel)]="selectedMagicInsightsGenerateCount">
                    <small class="text-grey-400 mt-1 d-block">
                      Leave blank to generate for all matching results.
                    </small>
                  </div>
                </div>
            }

              <div class="col-md-6">
                <label class="text-grey-700 text-bold-600 text-sm mb-2">Select Module</label>

                <div class="d-flex flex-column flex-gap-05 max-height-40vh overflow-auto scrollbar-show pr-1">
                  @for (module of modulesInfo; track $index) {
                    <label class="zint-base-card p-3 mb-0 d-flex align-items-center cursor-pointer transition-all position-relative"
                           [class.selected-module-card]="selectedModuleId === module.id"
                           [class.bg-white]="selectedModuleId !== module.id">

                      <div class="custom-control custom-radio">
                        <input type="radio"
                               [value]="module.id"
                               [(ngModel)]="selectedModuleId"
                               name="selectedModules"
                               (ngModelChange)="handleSelectedModuleIdsChange()"
                               class="custom-control-input">
                        <label class="custom-control-label"></label>
                      </div>

                      <div class="d-flex flex-column ml-2">
                        <span class="text-grey-700 text-bold-600">{{ module.name }}</span>
                      </div>

                      @if(selectedModuleId === module.id) {
                        <i class="fas fa-check-circle text-bear-blue position-absolute" style="right: 1rem;"></i>
                      }
                    </label>
                  }
                </div>
              </div>
            </div>

            <div class="bg-grey-50 border-rounded-05 p-3 mt-4">
                <div class="d-flex align-items-center">
                  <i class="fal fa-info-circle text-bear-blue mr-3 font-size-1-5"></i>
                  <div class="text-grey-600 extra-details line-height-normal flex-1">
                    <span class="d-block mr-4">
                      Usage is calculated as: <span class="text-bold-600"># Companies × # Unanswered Questions in Module</span>
                    </span>
                    <span class="d-block">
                        View and manage your quota <a href="/manage-quota?type=Magic%20Insights%20Answer" target="_blank" class="btn-link text-bear-blue">here</a>.
                    </span>
                    <span class="d-block">
                        Read more about Magic Insights Quotas <a href="https://support.zint.io/hc/en-gb/articles/32729820881309-How-to-assign-Magic-Insight-Answer-Credits" target="_blank" class="btn-link text-bear-blue">in the knowledge base</a>.
                    </span>
                  </div>
                </div>
             </div>


          <div class="row mt-3">
            @if (loadingQuotas) {
                <div class="col-md-12">
                    <div class="d-flex justify-content-center">
                        <zint-loader size="xSmall"></zint-loader> &nbsp;&nbsp;&nbsp; Pulling Your Quotas...
                    </div>
                </div>
            } @else {
                @if (monthlyQuotaDetails) {
                    <div class="col-md-6">
                        <progress-bar [label]="'Monthly Quota'" [usage]="monthlyQuotaDetails.usage" [quota]="monthlyQuotaDetails.quota"></progress-bar>
                    </div>
                }
                @if (bulkQuotaDetails) {
                    <div class="col-md-6">
                        <progress-bar [label]="'Bulk Quota'" [usage]="bulkQuotaDetails.usage" [quota]="bulkQuotaDetails.quota"></progress-bar>
                    </div>
                }
            }
         </div>

        <div class="d-flex justify-content-end align-items-center mt-4 pt-3 border-top border-light">
           <button class="rounded-btn-base rounded-btn-dark btn-p-md mr-3" data-dismiss="modal">
             Cancel
           </button>

           @if (canConfirmGeneration) {
            <button class="rounded-btn-base rounded-btn-dark-cta btn-p-lg shadow-sm d-flex align-items-center"
                    [disabled]="!selectedMagicModuleIds?.length || loadingState.loadingGenerateMagicInsights"
                    (click)="confirmGenerateMIForSelectedCompanies()">
              @if(loadingState.loadingGenerateMagicInsights) {
                <i class="fas fa-spinner fa-spin mr-2"></i> Generating...
              } @else {
                <i class="fal fa-wand-magic mr-2"></i> Generate Insights
              }
            </button>
          }
        </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
